export default __webpack_public_path__ + "static/media/trylleby-property-02.17b44b7e.jpg";